export default {
    setToken(token) {
        sessionStorage["token"] = "Bearer " + token
        return token
    },
    getToken() {
        const token = sessionStorage["token"]
        return token
    },
    clearToken(){
        sessionStorage.removeItem("token")
    },
    setUserActions(actions){
        sessionStorage['userAction'] = actions; 
    },
    getUserActions(){
        let userActionList = sessionStorage["userAction"];
        return userActionList
    },
    clearUserActions(){
        sessionStorage.removeItem("userAction")
    },
    setUsername(username) {
        sessionStorage["username"] = username
    },
    getUsername() {
        const username = sessionStorage["username"]
        return username
    },
    clearUsername() {
        sessionStorage.removeItem("username")
    }
}



// WEBPACK FOOTER //
// ./src/api/authority.js